import { useRef } from "react";
import useDropdownData from "../../../hooks/useDropdownData";
import { Button, FormFieldSet } from "../../../components";

const Locations = ({
  index,
  formData,
  errors,
  isEditable,
  handleLocationChange,
  hasDefaultACheck = false,
  location,
  handleBillingAddressChange,
  showDeleteButton = false,
  removeLocation = null,
}) => {
  const containerRef = useRef(null);
  const { data: countryOptions, handleScroll: handleCountriesScroll } =
    useDropdownData("countriesUsAndCanada", 10, {}, {}, `countries_${index}`);

  const countryId = countryOptions.find(
    (item) => item.label === formData.locations[index]?.country
  )?.id;

  const {
    data: stateOptions,
    searchValue: stateSearch,
    handleSearch: handleStateSearch,
    resetSearch: resetStateSearch,
    handleScroll: handleStateScroll,
  } = useDropdownData(
    "states",
    10,
    { country: formData.locations[index]?.country },
    { countrySearch: countryId },
    `states_${index}`
  );

  const {
    data: cityOptions,
    searchValue: citySearch,
    handleSearch: handleCitySearch,
    resetSearch: resetCitySearch,
    handleScroll: handleCityScroll,
  } = useDropdownData(
    "cities",
    10,
    {
      country: formData.locations[index]?.country,
      state: formData.locations[index]?.state,
    },
    { countrySearch: countryId, stateSearch: formData.locations[index]?.state },
    `cities_${index}`
  );

  return (
    <div key={index} className="mb-6">
      {index !== 0 && showDeleteButton && (
        <div className="flex justify-end">
          <Button
            // variant="outline"
            type={"icon"}
            size={"sm"}
            // title="add more"
            icon={"delete"}
            color={"neutrals"}
            onClick={() => removeLocation(index)}
            disabled={!isEditable}
          />
        </div>
      )}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 md:gap-6 max-w-7xl">
        <div className="md:col-span-1">
          <FormFieldSet
            type="text"
            title="Address Line 1"
            placeholder="Enter Address"
            value={formData?.locations?.[index]?.address1 || ""}
            onChange={(value) => handleLocationChange(index, "address1", value)}
            error={errors.locations?.[index]?.address1}
            disabled={!isEditable}
          />
        </div>
        <div className="md:col-span-1">
          <FormFieldSet
            type="text"
            title="Address Line 2"
            placeholder="Enter Address"
            value={formData?.locations?.[index]?.address2 || ""}
            onChange={(value) => handleLocationChange(index, "address2", value)}
            error={errors.locations?.[index]?.address2}
            disabled={!isEditable}
          />
        </div>
        <div className="md:col-span-1 lg:col-span-1">
          <FormFieldSet
            type="select"
            title="Country"
            keyname="countries"
            placeholder="Select Country"
            options={countryOptions}
            value={formData.locations[index]?.country || ""}
            onChange={(value) => handleLocationChange(index, "country", value)}
            error={errors.locations?.[index]?.country}
            showButton
            // showSearch
            disabled={!isEditable}
          />
        </div>
        <div className="md:col-span-1">
          <FormFieldSet
            type="select"
            title="State"
            keyname="states"
            placeholder="Select State"
            options={stateOptions}
            searchValue={stateSearch}
            onSearch={handleStateSearch}
            onClose={resetStateSearch}
            showSearch
            value={formData.locations[index]?.state || ""}
            onChange={(value) => handleLocationChange(index, "state", value)}
            error={errors.locations?.[index]?.state}
            disabled={!isEditable || !formData.locations[index]?.country}
            refData={containerRef}
            handleScroll={() => handleStateScroll(containerRef)}
          />
        </div>
        <div className="md:col-span-1">
          <FormFieldSet
            type="select"
            title="City"
            keyname="cities"
            placeholder="Select City"
            options={cityOptions}
            searchValue={citySearch}
            onSearch={handleCitySearch}
            onClose={resetCitySearch}
            showSearch
            value={formData.locations[index]?.city || ""}
            onChange={(value) => handleLocationChange(index, "city", value)}
            error={errors.locations?.[index]?.city}
            disabled={
              !isEditable ||
              !formData.locations[index]?.country ||
              !formData.locations[index]?.state
            }
            refData={containerRef}
            handleScroll={() => handleCityScroll(containerRef)}
          />
        </div>
        <div className="md:col-span-1 lg:col-span-1">
          <FormFieldSet
            type="text"
            title="Zip Code"
            placeholder="Enter Zip Code"
            value={formData?.locations?.[index]?.zipCode || ""}
            onChange={(value) => handleLocationChange(index, "zipCode", value)}
            error={errors.locations?.[index]?.zipCode}
            disabled={!isEditable}
          />
        </div>
        {/* {hasDefaultACheck && (
          <div>
            <FormFieldSet
              type="checkbox"
              title=""
              options={[{ label: "Default Billing Address", value: "true" }]}
              values={location?.isDefaultInvoice ? ["true"] : []}
              onChange={() => handleBillingAddressChange(index)}
              error={errors.locations?.[index]?.isDefaultInvoice}
              multiple
              disabled={!isEditable}
            />
          </div>
        )} */}
      </div>
      {hasDefaultACheck && (
        <div>
          <FormFieldSet
            type="checkbox"
            title=""
            options={[{ label: "Default Invoice Address", value: "true" }]}
            values={location?.isDefaultInvoice ? ["true"] : []}
            onChange={() => handleBillingAddressChange(index)}
            error={errors.locations?.[index]?.isDefaultInvoice}
            multiple
            disabled={!isEditable}
          />
        </div>
      )}
    </div>
  );
};

export default Locations;
